export default {
  delayedPercentage(state, getters) {
    const { delayed = 0 } = state.openShipmentOrders;

    return getters.calculateDelayedPercentage(delayed);
  },
  delayedLp(state, getters) {
    const { delayed_lp = 0 } = state.openShipmentOrders;

    return getters.calculateDelayedPercentage(delayed_lp);
  },
  delayedWithOcurrence(state, getters) {
    const { delayed_with_ocurrence = 0 } = state.openShipmentOrders;

    return getters.calculateDelayedPercentage(delayed_with_ocurrence);
  },
  mostDelayedBusinessDaysPassed(state) {
    const {
      openShipmentOrders: {
        most_delayed: {
          business_days = 0,
        } = {},
      } = {},
    } = state || {};

    return business_days;
  },
  calculateDelayedPercentage: state => value =>
    (value / state.openShipmentOrders.total) * 100
  ,
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-open-shipment/store/getters.js